import { Link } from '#components/atoms/link/Link.tsx';
import { CheckmarkList } from '#components/atoms/lists/checkmark-list/CheckmarkList.tsx';
import { AuthLayout } from '#components/patterns/layouts/auth/AuthLayout.tsx';
import { SignupForm } from '../form/SignupForm.tsx';

type Props = {
  onSuccessfulSubmit: () => void;
};

/**
 * Very similar to the standard Signup page, but for users who indicated they want to
 * sign up for the pro plan straightaway.
 */
export function SignupPro({ onSuccessfulSubmit }: Props) {
  return (
    <AuthLayout
      headerText={
        <div>
          Already have an account?{' '}
          <Link className="a" to="/auth/login">
            Sign in
          </Link>
        </div>
      }
    >
      <div className="simple-page-content">
        <h1 className="h2 mb-32">Get started with Pro</h1>
        <CheckmarkList>{['Priority support', 'Guaranteed uptime', 'Unlimited hosts']}</CheckmarkList>
        <SignupForm onSuccessfulSubmit={onSuccessfulSubmit} />
      </div>
    </AuthLayout>
  );
}
